// Third-party packages
import {
	APP_CONF_VARS,
} from '@appConf/vars.conf';
import {
	useQuery,
} from '@tanstack/react-query';
import {
	useEffect,
	useRef,
} from 'react';
import {
	useDispatch,
	useSelector,
} from 'react-redux';

// Project modules
import {
	refreshSession,
} from '@api/session';
import {
	useUserActivity,
} from '@hooks/useUserActivity';
import {
	userLogout,
	userUpdateSession,
} from '@stores/_slices/user';
import {
	selectUserState,
} from '@stores/selectors/userSelectors';

export const useSessionRefresher = () => {
	const user = useSelector(selectUserState);
	const dispatch = useDispatch();

	const {
		consumeActivity,
		isActiveUser,
	} = useUserActivity(APP_CONF_VARS.timeout.reload_session);

	const lastSessionRefresh = useRef(Date.now());

	const {
		data: refreshSessionData,
		error: refreshSessionError,
		isFetching: isRefreshing,
		refetch,
	} = useQuery({
		enabled: false,
		queryFn: refreshSession,
		queryKey: [
			'reload_session',
		],
	});

	useEffect(() => {
		const interval = setInterval(() => {
			const now = Date.now();
			const elapsed = now - lastSessionRefresh.current;

			const shouldRefresh =
				user.authenticated &&
        elapsed >= APP_CONF_VARS.timeout.reload_session &&
        isActiveUser;

			if (shouldRefresh) {
				refetch();
				lastSessionRefresh.current = now;
				consumeActivity();
			}
		}, 1000);

		return () => clearInterval(interval);
	}, [
		user.authenticated,
		isActiveUser,
		consumeActivity,
		lastSessionRefresh,
		refetch,
	]);

	useEffect(() => {
		if (refreshSessionData && refreshSessionData.status === 200) {
			dispatch(userUpdateSession());
		} else if (refreshSessionData && refreshSessionData.status !== 200) {
			dispatch(userLogout());
		}
	}, [
		refreshSessionData,
		dispatch,
	]);


	return {
		isRefreshing,
		refreshSessionData,
		refreshSessionError,
	};
};
